module.exports = __webpack_public_path__ + "media/images/procedure_managements/what_is/img_mobile_3-d7b39f74a8c268eb99d053ae1f120fac.png";